import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Button, Checkbox, FormGroup, InputGroup, Switch } from "@blueprintjs/core";
import { IntegrationStore } from "../../stores/xml-integracao/IntegrationStore";
import { toast } from "react-toastify";
import { MODELOS_INTEGRATION } from "../../utils";

@observer
export default class Dominio extends React.Component<{}, {}> {

  obs = observable({})

  constructor(props: {}) {
    super(props);
  }

  async handleSaveToken() {

    if (!IntegrationStore.obs.selectedEmpresa.cnpj) {
      toast.warning('Você precisa selecionar uma empresa.', {});
      return
    }

    if (!Object.values(IntegrationStore.obs.modelos_integration_dominio).some(Boolean)) {
      toast.warning('Você precisa selecionar pelo menos um Modelos de Importação.', {});
      return
    }

    let data = {
      token: IntegrationStore.obs.token_cliente_dominio,
      cnpj: IntegrationStore.obs.selectedEmpresa.cnpj,
      envio_automatico: IntegrationStore.obs.envio_automatico_dominio_api,
      tipo: "dominio",
      modelos_integration_dominio: IntegrationStore.obs.modelos_integration_dominio
    }

    await IntegrationStore.handleSaveToken(data)

  }

  handleChangeEnvio = (e) => {

    const newValue = e.target.checked;

    IntegrationStore.obs.envio_automatico_dominio_api = newValue

  };

  render() {

    return (
      <>

        <div style={{ background: "#f5f8fa", borderLeft: "3px solid #2b82bc", padding: "10px 14px", borderRadius: 4, marginTop: 15, marginBottom: 15 }}>
          <p style={{ margin: 0, fontSize: 11, color: "#394b59", lineHeight: 1.6 }}>
            <strong>DOMÍNIO:</strong> integração realizada via <strong>ONVIO</strong>.
          </p>
        </div>

        <FormGroup label="Envio Automático">
          <Switch
            label={IntegrationStore.obs.envio_automatico_dominio_api ? "Ativado" : "Desativado"}
            checked={IntegrationStore.obs.envio_automatico_dominio_api}
            onChange={(e: any) => this.handleChangeEnvio(e)} />
        </FormGroup>

        {IntegrationStore.obs.envio_automatico_dominio_api && (<>
          <FormGroup label="Modelos de Importação" labelInfo="*">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(100px, 1fr))", gap: 15, width: "max-content" }}>
              {MODELOS_INTEGRATION.map((item) => (
                <Checkbox
                  key={item.id}
                  type="checkbox"
                  label={item.name}
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    width: "max-content",
                    maxWidth: "100%",
                  }}
                  checked={!!IntegrationStore.obs.modelos_integration_dominio[item.id]}
                  onChange={(e: any) => {
                    IntegrationStore.obs.modelos_integration_dominio = {...IntegrationStore.obs.modelos_integration_dominio, [item.id]: e.target.checked};
                  }}
                />
              ))}
            </div>
          </FormGroup>
        </>)}

        <FormGroup label="Token cliente Domínio" labelInfo="*">
          <InputGroup
            style={{ width: 500 }}
            value={IntegrationStore.obs.token_cliente_dominio}
            onChange={(e: any) => IntegrationStore.obs.token_cliente_dominio = e.target.value}
          />
        </FormGroup>

        <Button intent="primary" onClick={() => this.handleSaveToken()}>Salvar configuração</Button>

      </>
    )
  }


}